import e from"react";var r=function(r){var t=r.as,a=void 0===t?"div":t,i=r.children,o=a;return e.createElement(o,{className:"l-layout__item"},i)};export{r as LayoutItem};
//# sourceMappingURL=LayoutItem.js.map
